module.exports = __webpack_public_path__ + "img/UI_common_framelabelDX_01_c5a163445.png";